export class JobType {
    readonly jobTypeId: number;
    readonly jobTypeName: string;
    readonly payLabel: string;

    constructor(jobTypeId: number, jobTypeName: string, payLabel?: string) {
        this.jobTypeId = jobTypeId;
        this.jobTypeName = jobTypeName;
        this.payLabel = payLabel;
    }

    public static FullTime = new JobType(1, "Full-time", "salary");
    public static PartTime = new JobType(2, "Part-time", "salary");
    public static Contract = new JobType(4, "Contract", "pay rate");
    public static Locum = new JobType(7, "Locum", "pay rate");

    public isContractOrLocum = (): boolean =>
        JobType.isContractOrLocum(this.jobTypeId);

    public isFullTimeOrPartTime = (): boolean =>
        JobType.isFullTimeOrPartTime(this.jobTypeId);

    public static asArray = () => [
        JobType.FullTime,
        JobType.PartTime,
        JobType.Contract,
        JobType.Locum,
    ];

    public static fromId = (id: number) =>
        JobType.asArray().find(t => t.jobTypeId === id);

    public static isContractOrLocum = (id: number): boolean =>
        id === JobType.Contract.jobTypeId || id === JobType.Locum.jobTypeId
            ? true
            : false;

    public static isFullTimeOrPartTime = (id: number): boolean =>
        id === JobType.FullTime.jobTypeId || id === JobType.PartTime.jobTypeId
            ? true
            : false;
}
